var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"SourceLink",attrs:{"href":_vm.fullUrl,"target":"_blank"}},[_vm._v("ソースを確認する："+_vm._s(_vm.sourcePath))])}
var staticRenderFns = []

export { render, staticRenderFns }